import type * as React from "react";

/** What an edit to a `type="number"` field is read from. */
export type NumberInputState = Pick<HTMLInputElement, "value" | "validity">;

/**
 * An `onInput` handler passing `read` the edits to a number field that leave
 * its `value` at "", which React's `onChange` can miss.
 *
 * A number input reports `value` as "" both when it is empty and when its text
 * can't be parsed yet ("2e" on its way to an exponent), and `onChange` skips an
 * edit that leaves `value` as it was. So deleting the whole of "2e" in one go,
 * or typing "e" into an empty field, never reaches `onChange`; the native
 * `input` event, which React passes on as `onInput` unfiltered, still fires.
 * Pair it with an `onChange` that calls the same `read`, which must therefore
 * be safe to call twice for one edit.
 */
export function readEmptyValueEdits(read: (input: NumberInputState) => void) {
  return (event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    if (event.currentTarget.value === "") {
      read(event.currentTarget);
    }
  };
}
